import { useMutation } from '@tanstack/react-query';

import { SalesPlanApi } from '../salesPlan.api';

export const useGetCalculationsOnProductUpdate = () => {
  return useMutation({
    mutationFn: SalesPlanApi.getCalculationsOnProductUpdate,
  });
};
